module.exports = __webpack_public_path__ + "static/media/zeus.7dcf7d7e.png";